export default __webpack_public_path__ + "resources/icons/d212-1740.png";